import {useRef } from 'react'; 
import useOutsideClick from '@/components/close_modal_outside_click';
const ResourcesModal = ({
  children,
  show,
  setShow, 
  no_close_on_outside_click

}) => {
  const modalBody = useRef()
  if (!no_close_on_outside_click) {
   useOutsideClick(modalBody, () => setShow(false) )
  }
   const handleClick = () => {
      setShow(false);
  };
  const content = show && (
    <div className="lexcms-resources-modal-overlay">
      <div ref={modalBody} className="lexcms-resources-modal">
        <div className="lexcms-resources-modal-header">
          <div
            className="lexcms-resources-modal-close"
            type="button"
            onClick={handleClick}
          >
            Close
          </div>
        </div>
        <div className="lexcms-resources-modal-content">{children}</div>
      </div>
    </div>
  );

  return content;
};

export default ResourcesModal;
